import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sen-app-roof-plan',
  templateUrl: './roof-plan.component.html',
  styleUrls: ['./roof-plan.component.scss']
})
export class RoofPlanComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
